import React, { FC, MouseEvent, useCallback } from "react";
import { Link as RouterLink, LinkProps } from "react-router-dom";
import classnames from "classnames";

interface Props extends LinkProps {
  disabled?: boolean;
}

const Link: FC<Props> = ({
  disabled = false,
  className,
  onClick,
  ...props
}) => {
  const handleClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      if (disabled) {
        e.preventDefault();
      }

      onClick?.(e);
    },
    [disabled, onClick]
  );

  return (
    <RouterLink
      {...props}
      className={classnames("Link", className, { disabled })}
      aria-disabled={disabled}
      onClick={handleClick}
    />
  );
};

export default Link;
